import Swiper from "./swiper-bundle.esm.browser.min.js";

if (!customElements.get("collections-nav")) {
  customElements.define(
    "collections-nav",
    class CollectionsNav extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.scrollableElement = this.querySelector(
          ".secondary-navigation__ul",
        );
        this.container = this.querySelector(".secondary-navigation");
        this.swiperEl = this.querySelector('.swiper');
        this.dataCenterSlides = this.dataset.centerSlides === '';

       this.initSwiper();
       this.initButtons();
      }

      initButtons(){
        const buttons = this.querySelectorAll('.collections-nav__nav-link');
        buttons.forEach((button) => {
          button.addEventListener('click', (event) => {
            // event.preventDefault();
            const targetBlockId = button.dataset.targetBlockId;
            const slideId = button.dataset.slideId;

            const targetBlock = document.getElementById(targetBlockId);
            if (targetBlock){
              targetBlock.scrollIntoView({
                behavior: 'smooth',
              });
            }
            // window.location.hash = targetBlockId;
            
            // this.swiper.slideTo(slideId);
            this.activeSlide?.classList.remove('collections-nav__nav-slide--active');

            this.activeSlide = this.swiper.slides[slideId];
            this.activeSlide.classList.add('collections-nav__nav-slide--active');
          });
        });
      }

      initSwiper(){
        // functions        
        const scrollToActiveSlide = (swiperEvent) => {
          const activeClass = 'secondary-navigation__swiper-slide--active'
          const slides = [...swiperEvent.slides];

          const activeSlideIndex = slides.findIndex((el) => el.classList.contains(activeClass));
          if (activeSlideIndex) {
            const speed = activeSlideIndex * 220
            swiperEvent.slideTo(activeSlideIndex, speed, true)
          }
        }

        const centerSlides = (swiperEvent) => {
          const shouldBeCentered = swiperEvent.snapGrid.length === 1 && swiperEvent.snapGrid[0] === -0;
          swiperEvent.wrapperEl.classList.toggle('secondary-navigation__swiper-wrapper--center', shouldBeCentered)
        }

        // swiper initialization
        this.swiper = new Swiper(this.swiperEl, {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 8,
          init: false,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        });

        this.swiper.on('afterInit', scrollToActiveSlide)
        if (this.dataCenterSlides){
          this.swiper.on('init', centerSlides)
          this.swiper.on('resize', centerSlides)
        }
        
        // init
        this.swiper.init();


        const threshold = window.innerWidth < 899 ? 0.7 : 1;

        const intersection = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.activeSlide?.classList.remove('collections-nav__nav-slide--active');
              const slideId = entry.target.dataset.slideId;
              const targetBlockId = entry.target.dataset.blockId;
              this.swiper.slideTo(slideId);
              const activeSlide = this.swiper.slides[slideId];

              activeSlide.classList.add('collections-nav__nav-slide--active');
              this.activeSlide = activeSlide;
            }
          });
        },
      {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: threshold,
      }
      );

        const collectionListItems = document.querySelectorAll('.colls-list__item');

        collectionListItems.forEach((item) => {
          intersection.observe(item);
        });
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
      }

    },
  );
}
